<template lang="pug">
div
  v-textarea(
    v-model='infoModel.remarks',
    label='Heb je opmerkingen over je aanvraag?',
    solo
    )

  .tos
    b Voordat je de aanvraag kan versturen, dien je akkoord te gaan met het onderstaande:
    br
    p Met het versturen van deze aanvraag geef je toestemming voor het digitaal verwerken van je persoonlijke gegevens in ons systeem.

    v-checkbox(
      v-model='infoModel.confirmCheckAndProcessing',
      label='Ja, ik ga akkoord met het bovenstaande',
      color='primary',
      hide-details,
      required,
      :disabled='isPortal && !isNew'
      )

</template>

<script>
export default {
  props: {
    value: Object,
    isPortal: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      infoModel: this.value
    }
  },

  computed: {
    confirmCheckAndProcessingValidationErrors () {
      const errors = []
      if (!this.$v.infoModel.confirmCheckAndProcessing.$dirty) return errors
      !this.$v.infoModel.confirmCheckAndProcessing.required && errors.push('Dit veld is verplicht')
      return errors
    }
  },

  validations: {
    infoModel: {
      confirmCheckAndProcessing: {
        mustAccept: (v) => v === true
      }
    }
  },

  watch: {
    '$v.$invalid': {
      handler: function (invalid) {
        this.$emit('setValid', {
          modelName: 'infoModel',
          valid: !invalid
        })
      },
      deep: true,
      immediate: true
    },

    value (v) {
      this.infoModel = v
    },

    infoModel: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/variables.scss";

.optional,
.tos {
  background: $accent;
  padding: $g;
}
</style>
